



// // import React, { useState, useEffect } from "react";
// // import { FaEdit, FaTrash, FaSave } from "react-icons/fa";
// // import axios from "axios";
// // import { useLoader } from "../../../../context/LoaderProvider";
// // const Employee = () => {
// //     // const [employees, setEmployees] = useState([]);
// //     const [showModal, setShowModal] = useState(false);
// //     const [isEditing, setIsEditing] = useState(false);
// //     const [editIndex, setEditIndex] = useState(null);
// //     const [loading, setLoading] = useState(true);
// //     const [editEmployeeId, setEditEmployeeId] = useState(null);
// //     const [vendorId, setVendorId] = useState(null);
// //     const { showLoader, hideLoader } = useLoader();
// //     const [form, setForm] = useState({
// //         firstName: "",
// //         lastName: "",
// //         email: "",
// //         mobileNumber: "",
// //         city: "",
// //         businessCategory: "FOOD_AND_BEVERAGES",
// //         businessVerticals: [],
// //         username: "sddeda",
// //         password: "",
// //         role: "ROLE_VENDOR",
// //         roles: [], // ✅ IMPORTANT
// //         businessModules: [], // ✅

// //     });

// //     const businessVerticalOptions = [
// //         "FOOD_AND_BEVERAGES",
// //         "CATERINGS_SERVICES",
// //         "LOGISTICS_SUPPLY",
// //         "FRESH_GROCERIES",
// //     ];

// //     const toggleBusinessVertical = (vertical) => {
// //         setForm((prevForm) => {
// //             const currentVerticals = prevForm.businessVerticals || []; // ✅ Ensure array
// //             const updated = currentVerticals.includes(vertical)
// //                 ? currentVerticals.filter((v) => v !== vertical)
// //                 : [...currentVerticals, vertical];

// //             return { ...prevForm, businessVerticals: updated };
// //         });
// //     };
// //     const [data, setData] = useState([]);
// //     const [error, setError] = useState("");
// //     const getTableHeight = () => {
// //         const width = window.innerWidth;

// //         if (width <= 600) return "400px";               // Mobile
// //         if (width >= 1000 && width <= 1300) return "400px"; // 1000–1300px
// //         if (width > 1300) return "500px";               // Large screens

// //         return "auto";  // default
// //     };
// //     // Save token and vendorId to localStorage (do this once, e.g., after login)
// //     useEffect(() => {
// //         const storedVendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken"); // ✅ Get token
// //     }, []);

// //     useEffect(() => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId || !token) {
// //             setError("Vendor ID or token not found in localStorage");
// //             return;
// //         }

// //         fetch(`https://backend.maamaas.com/subscription/api/get-employees/enquiry/${vendorId}`, {
// //             method: "GET",
// //             headers: {
// //                 "Accept": "application/json", // ✅ better than "*/*"
// //                 "Authorization": `Bearer ${token}`,
// //             },
// //         })
// //             .then(res => {
// //                 if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
// //                 return res.json();
// //             })
// //             .then(employees => {
// //                 setData(employees);
// //             })
// //             .catch(err => {
// //                 console.error("Fetch error:", err);
// //                 setError(err.message);
// //             })
// //     }, []);





// //     useEffect(() => {
// //         const storedVendorId = localStorage.getItem("vendorId");
// //         setVendorId(storedVendorId);
// //     }, []);
// //     const employeeData = {
// //         ...form,
// //         employeeRoles: form.employeeRoles, // ✅ Single role as enum value
// //     };


// //     const categories = ["Food", "Rooms", "BanquetHalls", "Fashions", "Groceries"];
// //     const modules = [
// //         "Home",
// //         "Company",
// //         "Settings_Controls",
// //         "Account_History",
// //         "Order_Management",
// //         "Menu_Management",
// //         "Inventory_Management",
// //         "Chef_Management",
// //         "Table_Management",
// //         "Delivery_Management",
// //         "Promotions_Discounts",
// //         "Report_Analysis"
// //     ];




// //     const handleChange = (e) => {
// //         const { name, value } = e.target;
// //         setForm(prev => ({ ...prev, [name]: value }));
// //     };

// //     const roleOptions = [
// //         { label: "Manager", value: "Manager" },
// //         { label: "Waiter", value: "Waiter" },
// //         { label: "Chef All", value: "Chef_All" },
// //         { label: "Chef North", value: "Chef_North" },
// //         { label: "Chef South", value: "Chef_South" },
// //         { label: "Chef Chines", value: "Chef_Chinese" },
// //         { label: "Chef Continental", value: "Chef_Continental" },
// //         { label: "Tea Stall", value: "Tea_stall" },
// //         { label: "Snacks", value: "Snacks" },
// //         { label: "Bakery ", value: "Bakery" },
// //     ];

// //     const toggleRole = (roleValue) => {
// //         setForm((prevForm) => {
// //             const currentRoles = prevForm.roles || [];
// //             const newRoles = currentRoles.includes(roleValue)
// //                 ? currentRoles.filter((r) => r !== roleValue)
// //                 : [...currentRoles, roleValue];

// //             return { ...prevForm, roles: newRoles };
// //         });
// //     };







// //     const toggleModule = (module) => {
// //         setForm((prevForm) => {
// //             const current = prevForm.businessModules || [];
// //             const newModules = current.includes(module)
// //                 ? current.filter((m) => m !== module)
// //                 : [...current, module];
// //             return { ...prevForm, businessModules: newModules };
// //         });
// //     };


// //     const handleSubmit = async () => {
// //         const parentId = localStorage.getItem("vendorId");
// //         // const authToken = localStorage.getItem("authToken");

// //         if (!parentId) {
// //             alert("Parent ID not found. Please login again.");
// //             return;
// //         }

// //         const payload = {
// //             vendorId: 0,
// //             name: `${form.firstName} ${form.lastName}`,
// //             email: form.email,
// //             mobileNumber: form.mobileNumber,
// //             city: form.city || "Unknown",
// //             businessVerticals: form.businessVerticals || [],
// //             parentId: Number(parentId),
// //             username: "dsafre",
// //             password: form.password,
// //             enabled: true,
// //             employeRole: form.roles[0] || "Manager", // ✅ send only one role as string
// //             role: "ROLE_VENDOR",
// //             accountNonLocked: true,
// //             accountNonExpired: true,
// //             credentialsNonExpired: true,
// //             businessModules: form.businessModules || [],

// //         };

// //         try {
// //             showLoader();
// //             const response = await axios.post(
// //                 "https://backend.maamaas.com/subscription/api/vendor/enquiry",
// //                 payload,
// //                 {
// //                     headers: {
// //                         "Content-Type": "application/json",
// //                         // Authorization: `Bearer ${authToken}`,
// //                     },
// //                 }
// //             );

// //             alert("Employee added successfully!");
// //             setShowModal(false);   // Optional: Close modal
// //             window.location.reload(); // ✅ Reload the page
// //         } catch (error) {
// //             // console.error("❌ Error adding employee:", {
// //             //     message: error.message,
// //             //     status: error.response?.status,
// //             //     data: error.response?.data,
// //             // });
// //             alert("Failed to add employee.");
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     const handleEditClick = (employee) => {
// //         setEditEmployeeId(employee.vendorId); // set ID
// //         setIsEditing(true); // modal is in edit mode

// //         // Pre-fill form with existing employee data
// //         setForm({
// //             name: employee.name || "",
// //             email: employee.email || "",
// //             mobileNumber: employee.mobileNumber || "",
// //             username: employee.username || "",
// //             roles: employee.employeRole ? [employee.employeRole] : [],
// //             businessVerticals: employee.businessVerticals || [],
// //             businessModules: employee.businessModules || [],
// //         });

// //         alert(`Selected Vendor ID: ${employee.vendorId}`); // optional
// //         setShowModal(true); // show modal
// //     };



// //     const updateEmployee = async () => {
// //         if (!editEmployeeId) {
// //             alert("❌ No employee selected for update.");
// //             return;
// //         }

// //         alert(`Updating Vendor ID: ${editEmployeeId}`);
// //         const token = localStorage.getItem("token"); // Bearer token
// //         // Prepare the payload according to your backend
// //         const employeeData = {
// //             businessModules: form.businessModules || [], // send selected modules
// //             // add other fields if backend requires
// //         };

// //         try {
// //             showLoader();

// //             const response = await fetch(
// //                 `https://backend.maamaas.com/subscription/vendor-enquiries/edit/${editEmployeeId}`,
// //                 {
// //                     method: "PUT",
// //                     headers: {
// //                         "Content-Type": "application/json",
// //                         "Authorization": `Bearer ${token}`,
// //                     },
// //                     body: JSON.stringify(employeeData),
// //                 }
// //             );

// //             const contentType = response.headers.get("content-type");
// //             const responseBody = contentType && contentType.includes("application/json")
// //                 ? await response.json()
// //                 : await response.text();

// //             if (!response.ok) {
// //                 throw new Error(`❌ Failed to update (Status ${response.status}): ${JSON.stringify(responseBody)}`);
// //             }

// //             alert("✅ Employee updated successfully!");
// //             // fetchEmployees(); // refresh table
// //             setShowModal(false); // close modal
// //         } catch (error) {
// //             // alert("❌ Update failed: " + error.message);
// //         } finally {
// //             hideLoader();
// //         }
// //     };







// //     const handleDelete = async (vendorId) => {
// //         if (!vendorId) return alert("Invalid employee ID");

// //         const token = localStorage.getItem("token"); // get token from localStorage /api/delete/enquiry/{id}
// //         if (!token) return alert("Token not found");

// //         try {
// //             const res = await fetch(
// //                 `https://backend.maamaas.com/subscription/api/delete/enquiry/${vendorId}`,
// //                 {
// //                     method: "DELETE",
// //                     headers: {
// //                         "accept": "*/*",
// //                         "Authorization": `Bearer ${token}`, // token included
// //                     },
// //                 }
// //             );

// //             if (!res.ok) throw new Error(`Failed to delete. Status ${res.status}`);

// //             // Remove the deleted employee from state
// //             setData((prev) => prev.filter((emp) => emp.vendorId !== vendorId));
// //             alert("Employee deleted successfully.");
// //         } catch (err) {
// //             alert("Delete Error: " + err.message);
// //         }
// //     };




// //     const tableCellStyle = {
// //         border: "1px solid #ddd",
// //         padding: "8px",
// //     };
// //     const buttonStyle = {

// //         backgroundColor: '#dc3545',
// //         color: 'white',
// //         border: 'none',
// //         borderRadius: '4px',
// //         cursor: 'pointer',
// //         marginRight: "5px"
// //     };

// //     return (
// //         <div className="billingswaraper" style={{ padding: "0px", marginTop: "10px", }}>
// //             <button onClick={() => {
// //                 setShowModal(true);
// //                 setIsEditing(false);
// //                 setEditIndex(null);
// //                 setForm({
// //                     firstName: "",
// //                     lastName: "",
// //                     email: "",
// //                     mobileNumber: "",
// //                     employeeRoles: [],
// //                     businessCategory: "FOOD_AND_BEVERAGES",
// //                     businessModules: [],
// //                     username: "",
// //                     password: "",
// //                 });
// //             }} style={addButtonStyle}>Add +</button>
// //             <div style={{ height: getTableHeight(), overflowY: "auto" }}>
// //                 <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
// //                     <thead>
// //                         <tr>
// //                             <th style={thStyle}>S.No</th>
// //                             <th style={thStyle}>Name</th>

// //                             <th style={thStyle}>Email</th>
// //                             <th style={thStyle}>Mobile</th>
// //                             <th style={thStyle}>Role</th>
// //                             <th style={thStyle}>businessVerticals</th>
// //                             <th style={thStyle}>Modules</th>
// //                             <th style={thStyle}>Actions</th>
// //                         </tr>
// //                     </thead>
// //                     <tbody>
// //                         {data.length === 0 ? (
// //                             <tr>
// //                                 <td colSpan="9" style={tableCellStyle}>
// //                                     {error ? `⚠️ ${error}` : "Loading…"}
// //                                 </td>
// //                             </tr>
// //                         ) : (
// //                             data.map((item, index) => (
// //                                 <tr key={item.vendorId || index}>
// //                                     <td style={tableCellStyle}>{index + 1}</td>
// //                                     <td style={tableCellStyle}>{item.name}</td>
// //                                     <td style={tableCellStyle}>{item.email}</td>
// //                                     <td style={tableCellStyle}>{item.mobileNumber}</td>
// //                                     <td style={tableCellStyle}>{item.employeRole}</td>
// //                                     <td style={tableCellStyle}>{item.businessVerticals.join(", ")}</td>
// //                                     <td style={tableCellStyle}>
// //                                         {item.businessModules.map((module, idx) => (
// //                                             <span key={idx}>
// //                                                 {module}
// //                                                 <br />
// //                                             </span>
// //                                         ))}
// //                                     </td>
// //                                     <td style={tableCellStyle}>
// //                                         {/* Edit button */}
// //                                         <button
// //                                             type="button"
// //                                             onClick={() => handleEditClick(item)}
// //                                             style={{
// //                                                 ...buttonStyle,
// //                                                 background: "none",
// //                                                 border: "none",
// //                                                 cursor: "pointer",
// //                                                 fontSize: "18px",
// //                                                 color: "#4A148C",
// //                                                 marginRight: "8px",
// //                                             }}
// //                                         >
// //                                             <FaEdit />
// //                                         </button>


// //                                         {/* Delete button */}
// //                                         <button
// //                                             type="button"
// //                                             onClick={() => handleDelete(item.vendorId)}
// //                                             style={{
// //                                                 background: "none",
// //                                                 border: "none",
// //                                                 cursor: "pointer",
// //                                                 fontSize: "18px",
// //                                                 color: "red",
// //                                             }}
// //                                             title="Delete Employee"
// //                                         >
// //                                             <FaTrash />
// //                                         </button>
// //                                     </td>
// //                                 </tr>
// //                             ))
// //                         )}
// //                     </tbody>



// //                 </table>
// //             </div>
// //             {showModal && (
// //                 <div style={modalOverlay}>
// //                     <div style={modalContent}>
// //                         <h3>{isEditing ? "Edit Employee" : "Add Employee"}</h3>
// //                         <input type="text" name="firstName" placeholder="First Name" value={form.name} onChange={handleChange} style={inputStyle} />
// //                         {/* <input type="text" name="lastName" placeholder="Last Name" value={form.lastName} onChange={handleChange} style={inputStyle} /> */}
// //                         <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} style={inputStyle} />
// //                         <input type="text" name="mobileNumber" placeholder="Mobile Number" value={form.mobileNumber} onChange={handleChange} style={inputStyle} />
// //                         <div style={{ marginTop: "10px" }}>
// //                             <label>Business Verticals:</label>
// //                             {businessVerticalOptions.map((vertical) => (
// //                                 <label key={vertical} style={{ marginRight: "10px" }}>
// //                                     <input
// //                                         type="checkbox"
// //                                         checked={form.businessVerticals?.includes(vertical)}
// //                                         onChange={() => toggleBusinessVertical(vertical)}
// //                                     />
// //                                     {vertical.replace(/_/g, " ")}
// //                                 </label>
// //                             ))}
// //                         </div>

// //                         <div>
// //                             <label>Roles:</label>
// //                             {roleOptions.map(({ label, value }) => (
// //                                 <label key={value} style={{ marginRight: "10px" }}>
// //                                     <input
// //                                         type="checkbox"
// //                                         checked={form.roles?.includes(value)}
// //                                         onChange={() => toggleRole(value)}
// //                                     />
// //                                     {label}
// //                                 </label>
// //                             ))}
// //                         </div>


// //                         <div style={{ marginTop: "10px" }}>
// //                             <label>Modules:</label>
// //                             {modules.map((module) => (
// //                                 <label key={module} style={{ marginRight: "10px" }}>
// //                                     <input
// //                                         type="checkbox"
// //                                         checked={form.businessModules.includes(module)}
// //                                         onChange={() => toggleModule(module)}
// //                                     />
// //                                     {module.replace(/_/g, " ")} {/* Optional: make labels readable */}
// //                                 </label>
// //                             ))}
// //                         </div>


// //                         <div style={{ marginTop: "20px", textAlign: "right" }}>
// //                             <button style={saveButton} onClick={isEditing ? updateEmployee : handleSubmit}>
// //                                 {isEditing ? "Update" : "Add"} Employee
// //                             </button>
// //                             <button
// //                                 onClick={() => {
// //                                     setShowModal(false);
// //                                     setIsEditing(false);
// //                                     setEditIndex(null);
// //                                     setForm({
// //                                         firstName: "",
// //                                         lastName: "",
// //                                         email: "",
// //                                         mobileNumber: "",
// //                                         employeeRoles: [],
// //                                         businessCategory: "FOOD_AND_BEVERAGES",
// //                                         businessModules: [],
// //                                         username: "",
// //                                         password: "",
// //                                     });
// //                                 }}
// //                                 style={cancelButton}
// //                             >
// //                                 Cancel
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}
// //         </div>
// //     );
// // };
// // //  all the 

// // // Styles
// // const thStyle = {
// //     border: "1px solid #ccc",
// //     backgroundColor: "#b15cd6",
// //     color: "#fff",
// //     padding: "8px",
// //     whiteSpace: "nowrap",
// //     overflow: "hidden",
// //     textOverflow: "ellipsis",
// //     maxWidth: "150px"
// // };

// // const tdStyle = {
// //     border: "1px solid #ccc",
// //     textAlign: "center",
// //     padding: "8px",
// //     whiteSpace: "nowrap",
// //     overflow: "hidden",
// //     textOverflow: "ellipsis",
// //     maxWidth: "97px",
// //     width: "150px",
// //     boxSizing: "border-box"
// // };

// // const evenRow = { backgroundColor: "#f9f9f9" };
// // const oddRow = { backgroundColor: "#fff" };
// // const inputStyle = { width: "100%", margin: "5px 0", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" };
// // const addButtonStyle = { padding: "8px 15px", backgroundColor: "#b15cd6", color: "#fff", border: "none", borderRadius: "4px", fontWeight: "bold", fontSize: "16px", marginBottom: "10px" };
// // const saveButton = { padding: "8px 15px", backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", marginRight: "10px" };
// // const cancelButton = { padding: "8px 15px", backgroundColor: "#ccc", color: "#fff", border: "none", borderRadius: "4px" };
// // const deleteButtonStyle = { backgroundColor: "#f44336", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
// // const deleteButtonStylee = { backgroundColor: "blue", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
// // const modalOverlay = {
// //     position: "fixed",
// //     top: 35,
// //     left: 0,
// //     zIndex: 1111,
// //     width: "100%",
// //     height: "100%",
// //     backgroundColor: "rgba(0, 0, 0, 0.5)",
// //     display: "flex",
// //     justifyContent: "center",
// //     alignItems: "center"
// // };
// // const modalContent = {
// //     backgroundColor: "#fff",
// //     padding: "24px",
// //     borderRadius: "12px",
// //     width: "100%",
// //     maxWidth: "500px",
// //     maxHeight: "90vh",
// //     overflowY: "auto",
// //     boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)", // Adds depth
// //     display: "flex",
// //     flexDirection: "column",
// //     gap: "16px" // Space between form elements
// // };

// // const checkboxLabel = {
// //     marginRight: "10px",
// //     display: "inline-block"
// // };

// // export default Employee;








// import React, { useState, useEffect } from "react";
// import { FaEdit, FaTrash, FaSave } from "react-icons/fa";
// import axios from "axios";
// import { useLoader } from "../../../../context/LoaderProvider";
// const Employee = () => {
//     // const [employees, setEmployees] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [isEditing, setIsEditing] = useState(false);
//     const [editIndex, setEditIndex] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [editEmployeeId, setEditEmployeeId] = useState(null);
//     const [vendorId, setVendorId] = useState(null);
//     const { showLoader, hideLoader } = useLoader();
//     const [form, setForm] = useState({
//         firstName: "",
//         lastName: "",
//         email: "",
//         mobileNumber: "",
//         city: "",
//         businessCategory: "FOOD_AND_BEVERAGES",
//         businessVerticals: [],
//         username: "sddeda",
//         password: "",
//         role: "ROLE_VENDOR",
//         roles: [], // ✅ IMPORTANT
//         businessModules: [], // ✅

//     });

//     const businessVerticalOptions = [
//         "FOOD_AND_BEVERAGES",
//         "CATERINGS_SERVICES",
//         "LOGISTICS_SUPPLY",
//         "FRESH_GROCERIES",
//     ];

//     const toggleBusinessVertical = (vertical) => {
//         setForm((prevForm) => {
//             const currentVerticals = prevForm.businessVerticals || []; // ✅ Ensure array
//             const updated = currentVerticals.includes(vertical)
//                 ? currentVerticals.filter((v) => v !== vertical)
//                 : [...currentVerticals, vertical];

//             return { ...prevForm, businessVerticals: updated };
//         });
//     };
//     const [data, setData] = useState([]);
//     const [error, setError] = useState("");
//     const getTableHeight = () => {
//         const width = window.innerWidth;

//         if (width <= 600) return "400px";               // Mobile
//         if (width >= 1000 && width <= 1300) return "400px"; // 1000–1300px
//         if (width > 1300) return "500px";               // Large screens

//         return "auto";  // default
//     };
//     // Save token and vendorId to localStorage (do this once, e.g., after login)
//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken"); // ✅ Get token
//     }, []);

//     useEffect(() => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId || !token) {
//             setError("Vendor ID or token not found in localStorage");
//             return;
//         }

//         fetch(`https://backend.maamaas.com/subscription/api/get-employees/enquiry/${vendorId}`, {
//             method: "GET",
//             headers: {
//                 "Accept": "application/json", // ✅ better than "*/*"
//                 "Authorization": `Bearer ${token}`,
//             },
//         })
//             .then(res => {
//                 if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
//                 return res.json();
//             })
//             .then(employees => {
//                 setData(employees);
//             })
//             .catch(err => {
//                 console.error("Fetch error:", err);
//                 setError(err.message);
//             })
//     }, []);





//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         setVendorId(storedVendorId);
//     }, []);
//     const employeeData = {
//         ...form,
//         employeeRoles: form.employeeRoles, // ✅ Single role as enum value
//     };


//     const categories = ["Food", "Rooms", "BanquetHalls", "Fashions", "Groceries"];
//     const modules = [
//         "Home",
//         "Company",
//         "Settings_Controls",
//         "Account_History",
//         "Order_Management",
//         "Menu_Management",
//         "Inventory_Management",
//         "Chef_Management",
//         "Table_Management",
//         "Delivery_Management",
//         "Promotions_Discounts",
//         "Report_Analysis"
//     ];




//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm(prev => ({ ...prev, [name]: value }));
//     };

//     const roleOptions = [
//         { label: "Manager", value: "Manager" },
//         { label: "Waiter", value: "Waiter" },
//         { label: "Chef All", value: "Chef_All" },
//         { label: "Chef North", value: "Chef_North" },
//         { label: "Chef South", value: "Chef_South" },
//         { label: "Chef Chines", value: "Chef_Chinese" },
//         { label: "Chef Continental", value: "Chef_Continental" },
//         { label: "Tea Stall", value: "Tea_stall" },
//         { label: "Snacks", value: "Snacks" },
//         { label: "Bakery ", value: "Bakery" },
//     ];

//     const toggleRole = (roleValue) => {
//         setForm((prevForm) => {
//             const currentRoles = prevForm.roles || [];
//             const newRoles = currentRoles.includes(roleValue)
//                 ? currentRoles.filter((r) => r !== roleValue)
//                 : [...currentRoles, roleValue];

//             return { ...prevForm, roles: newRoles };
//         });
//     };







//     const toggleModule = (module) => {
//         setForm((prevForm) => {
//             const current = prevForm.businessModules || [];
//             const newModules = current.includes(module)
//                 ? current.filter((m) => m !== module)
//                 : [...current, module];
//             return { ...prevForm, businessModules: newModules };
//         });
//     };


//     const handleSubmit = async () => {
//         const parentId = localStorage.getItem("vendorId");
//         // const authToken = localStorage.getItem("authToken");

//         if (!parentId) {
//             alert("Parent ID not found. Please login again.");
//             return;
//         }

//         const payload = {
//             vendorId: 0,
//             name: `${form.firstName} ${form.lastName}`,
//             email: form.email,
//             mobileNumber: form.mobileNumber,
//             city: form.city || "Unknown",
//             businessVerticals: form.businessVerticals || [],
//             parentId: Number(parentId),
//             username: "dsafre",
//             password: form.password,
//             enabled: true,
//             employeRole: form.roles[0] || "Manager", // ✅ send only one role as string
//             role: "ROLE_VENDOR",
//             accountNonLocked: true,
//             accountNonExpired: true,
//             credentialsNonExpired: true,
//             businessModules: form.businessModules || [],

//         };

//         try {
//             showLoader();
//             const response = await axios.post(
//                 "https://backend.maamaas.com/subscription/api/vendor/enquiry",
//                 payload,
//                 {
//                     headers: {
//                         "Content-Type": "application/json",
//                         // Authorization: `Bearer ${authToken}`,
//                     },
//                 }
//             );

//             alert("Employee added successfully!");
//             setShowModal(false);   // Optional: Close modal
//             window.location.reload(); // ✅ Reload the page
//         } catch (error) {
//             // console.error("❌ Error adding employee:", {
//             //     message: error.message,
//             //     status: error.response?.status,
//             //     data: error.response?.data,
//             // });
//             alert("Failed to add employee.");
//         } finally {
//             hideLoader();
//         }
//     };

//     const handleEditClick = (employee) => {
//         setEditEmployeeId(employee.vendorId); // set ID
//         setIsEditing(true); // modal is in edit mode

//         // Pre-fill form with existing employee data
//         setForm({
//             name: employee.name || "",
//             email: employee.email || "",
//             mobileNumber: employee.mobileNumber || "",
//             username: employee.username || "",
//             roles: employee.employeRole ? [employee.employeRole] : [],
//             businessVerticals: employee.businessVerticals || [],
//             businessModules: employee.businessModules || [],
//         });

//         alert(`Selected Vendor ID: ${employee.vendorId}`); // optional
//         setShowModal(true); // show modal
//     };



//     const updateEmployee = async () => {
//         if (!editEmployeeId) {
//             alert("❌ No employee selected for update.");
//             return;
//         }

//         alert(`Updating Vendor ID: ${editEmployeeId}`);
//         const token = localStorage.getItem("token"); // Bearer token
//         // Prepare the payload according to your backend
//         const employeeData = {
//             businessModules: form.businessModules || [], // send selected modules
//             // add other fields if backend requires
//         };

//         try {
//             showLoader();

//             const response = await fetch(
//                 `https://backend.maamaas.com/subscription/vendor-enquiries/edit/${editEmployeeId}`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         "Content-Type": "application/json",
//                         "Authorization": `Bearer ${token}`,
//                     },
//                     body: JSON.stringify(employeeData),
//                 }
//             );

//             const contentType = response.headers.get("content-type");
//             const responseBody = contentType && contentType.includes("application/json")
//                 ? await response.json()
//                 : await response.text();

//             if (!response.ok) {
//                 throw new Error(`❌ Failed to update (Status ${response.status}): ${JSON.stringify(responseBody)}`);
//             }

//             alert("✅ Employee updated successfully!");
//             // fetchEmployees(); // refresh table
//             setShowModal(false); // close modal
//         } catch (error) {
//             // alert("❌ Update failed: " + error.message);
//         } finally {
//             hideLoader();
//         }
//     };







//     const handleDelete = async (vendorId) => {
//         if (!vendorId) return alert("Invalid employee ID");

//         const token = localStorage.getItem("token"); // get token from localStorage /api/delete/enquiry/{id}
//         if (!token) return alert("Token not found");

//         try {
//             const res = await fetch(
//                 `https://backend.maamaas.com/subscription/api/delete/enquiry/${vendorId}`,
//                 {
//                     method: "DELETE",
//                     headers: {
//                         "accept": "*/*",
//                         "Authorization": `Bearer ${token}`, // token included
//                     },
//                 }
//             );

//             if (!res.ok) throw new Error(`Failed to delete. Status ${res.status}`);

//             // Remove the deleted employee from state
//             setData((prev) => prev.filter((emp) => emp.vendorId !== vendorId));
//             alert("Employee deleted successfully.");
//         } catch (err) {
//             alert("Delete Error: " + err.message);
//         }
//     };




//     const tableCellStyle = {
//         border: "1px solid #ddd",
//         padding: "8px",
//     };
//     const buttonStyle = {

//         backgroundColor: '#dc3545',
//         color: 'white',
//         border: 'none',
//         borderRadius: '4px',
//         cursor: 'pointer',
//         marginRight: "5px"
//     };

//     return (
//         <div className="billingswaraper" style={{ padding: "10px", marginTop: "10px", width:window.innerWidth>=992 ? "55vw": "90vw" , marginLeft: window.innerWidth < 769 ? "2vw" : "2vw" }}>
//             <button onClick={() => {
//                 setShowModal(true);
//                 setIsEditing(false);
//                 setEditIndex(null);
//                 setForm({
//                     firstName: "",
//                     lastName: "",
//                     email: "",
//                     mobileNumber: "",
//                     employeeRoles: [],
//                     businessCategory: "FOOD_AND_BEVERAGES",
//                     businessModules: [],
//                     username: "",
//                     password: "",
//                 });
//             }} style={addButtonStyle}>Add +</button>
//             <div style={{ height: getTableHeight(), overflowY: "auto" }}>
//                 <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
//                     <thead>
//                         <tr>
//                             <th style={thStyle}>S.No</th>
//                             <th style={thStyle}>Name</th>

//                             <th style={thStyle}>Email</th>
//                             <th style={thStyle}>Mobile</th>
//                             <th style={thStyle}>Role</th>
//                             <th style={thStyle}>businessVerticals</th>
//                             <th style={thStyle}>Modules</th>
//                             <th style={thStyle}>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {data.length === 0 ? (
//                             <tr>
//                                 <td colSpan="9" style={tableCellStyle}>
//                                     {error ? `⚠️ ${error}` : "Loading…"}
//                                 </td>
//                             </tr>
//                         ) : (
//                             data.map((item, index) => (
//                                 <tr key={item.vendorId || index}>
//                                     <td style={tableCellStyle}>{index + 1}</td>
//                                     <td style={tableCellStyle}>{item.name}</td>
//                                     <td style={tableCellStyle}>{item.email}</td>
//                                     <td style={tableCellStyle}>{item.mobileNumber}</td>
//                                     <td style={tableCellStyle}>{item.employeRole}</td>
//                                     <td style={tableCellStyle}>{item.businessVerticals.join(", ")}</td>
//                                     <td style={tableCellStyle}>
//                                         {item.businessModules.map((module, idx) => (
//                                             <span key={idx}>
//                                                 {module}
//                                                 <br />
//                                             </span>
//                                         ))}
//                                     </td>
//                                     <td style={{ ...tableCellStyle, padding: window.innerWidth < 1300 ? "5px" : " " }}>
//                                         {/* Edit button */}
//                                         <button
//                                             type="button"
//                                             onClick={() => handleEditClick(item)}
//                                             style={{
//                                                 ...buttonStyle,
//                                                 background: "none",
//                                                 border: "none",
//                                                 cursor: "pointer",
//                                                 fontSize: "18px",
//                                                 color: "#4A148C",
//                                                 marginRight: window.innerWidth < 1300 ? " " : "8px",
//                                             }}
//                                         >
//                                             <FaEdit />
//                                         </button>


//                                         {/* Delete button */}
//                                         <button
//                                             type="button"
//                                             onClick={() => handleDelete(item.vendorId)}
//                                             style={{
//                                                 background: "none",
//                                                 border: "none",
//                                                 cursor: "pointer",
//                                                 fontSize: "18px",
//                                                 color: "red",
//                                             }}
//                                             title="Delete Employee"
//                                         >
//                                             <FaTrash />
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))
//                         )}
//                     </tbody>



//                 </table>
//             </div>
//             {showModal && (
//                 <div style={modalOverlay}>
//                     <div style={modalContent}>
//                         <h3>{isEditing ? "Edit Employee" : "Add Employee"}</h3>
//                         <input type="text" name="firstName" placeholder="First Name" value={form.name} onChange={handleChange} style={inputStyle} />
//                         {/* <input type="text" name="lastName" placeholder="Last Name" value={form.lastName} onChange={handleChange} style={inputStyle} /> */}
//                         <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} style={inputStyle} />
//                         <input type="text" name="mobileNumber" placeholder="Mobile Number" value={form.mobileNumber} onChange={handleChange} style={inputStyle} />
//                         <div style={{ marginTop: "10px" }}>
//                             <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
//                                 Business Verticals:
//                             </label>
//                             <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
//                                 {businessVerticalOptions.map((vertical) => (
//                                     <label key={vertical} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
//                                         <input
//                                             type="checkbox"
//                                             checked={form.businessVerticals?.includes(vertical)}
//                                             onChange={() => toggleBusinessVertical(vertical)}
//                                             style={{ marginRight: "6px", cursor: "pointer" }}
//                                         />
//                                         {vertical.replace(/_/g, " ")}
//                                     </label>
//                                 ))}
//                             </div>
//                         </div>

//                         <div>
//                             <label>Roles:</label>
//                             <div style={{ display: "flex", flexWrap: "wrap", marginTop: "8px", gap: "10px" }}>
//                                 {roleOptions.map(({ label, value }) => (
//                                     <label key={value} style={{ display: "flex", alignItems: "center" }}>
//                                         <input
//                                             type="checkbox"
//                                             checked={form.roles?.includes(value)}
//                                             onChange={() => toggleRole(value)}
//                                             style={{ marginRight: "5px" }}
//                                         />
//                                         {label}
//                                     </label>
//                                 ))}
//                             </div>
//                         </div>


//                         <div style={{ marginTop: "10px" }}>
//                             <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
//                                 Modules:
//                             </label>
//                             <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
//                                 {modules.map((module) => (
//                                     <label key={module} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
//                                         <input
//                                             type="checkbox"
//                                             checked={form.businessModules.includes(module)}
//                                             onChange={() => toggleModule(module)}
//                                             style={{ marginRight: "6px", cursor: "pointer" }}
//                                         />
//                                         {module.replace(/_/g, " ")}
//                                     </label>
//                                 ))}
//                             </div>
//                         </div>


//                         <div style={{ marginTop: "20px", textAlign: "right" }}>
//                             <button style={saveButton} onClick={isEditing ? updateEmployee : handleSubmit}>
//                                 {isEditing ? "Update" : "Add"} Employee
//                             </button>
//                             <button
//                                 onClick={() => {
//                                     setShowModal(false);
//                                     setIsEditing(false);
//                                     setEditIndex(null);
//                                     setForm({
//                                         firstName: "",
//                                         lastName: "",
//                                         email: "",
//                                         mobileNumber: "",
//                                         employeeRoles: [],
//                                         businessCategory: "FOOD_AND_BEVERAGES",
//                                         businessModules: [],
//                                         username: "",
//                                         password: "",
//                                     });
//                                 }}
//                                 style={cancelButton}
//                             >
//                                 Cancel
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };
// //  all the 

// // Styles
// const thStyle = {
//     border: "1px solid #ccc",
//     backgroundColor: "#b15cd6",
//     color: "#fff",
//     padding: "8px",
//     whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis",
//     maxWidth: "150px"
// };

// const tdStyle = {
//     border: "1px solid #ccc",
//     textAlign: "center",
//     padding: "8px",
//     whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis",
//     maxWidth: "97px",
//     width: "150px",
//     boxSizing: "border-box"
// };

// const evenRow = { backgroundColor: "#f9f9f9" };
// const oddRow = { backgroundColor: "#fff" };
// const inputStyle = { width: "100%", margin: "5px 0", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" };
// const addButtonStyle = { padding: "8px 15px", backgroundColor: "#b15cd6", color: "#fff", border: "none", borderRadius: "4px", fontWeight: "bold", fontSize: "16px", marginBottom: "10px" };
// const saveButton = { padding: "8px 15px", backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", marginRight: "10px" };
// const cancelButton = { padding: "8px 15px", backgroundColor: "#ccc", color: "#fff", border: "none", borderRadius: "4px" };
// const deleteButtonStyle = { backgroundColor: "#f44336", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
// const deleteButtonStylee = { backgroundColor: "blue", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
// const modalOverlay = {
//     position: "fixed",
//     top: window.innerWidth < 500 ? 20 : 35,
//     left: 0,
//     zIndex: 1111,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center"
// };
// const modalContent = {
//     backgroundColor: "#fff",
//     padding: "24px",
//     borderRadius: "12px",
//     width: window.innerWidth < 500 ? "80%" : "100%",
//     maxWidth: "500px",
//     maxHeight: window.innerWidth < 500 ? "80vh" : "90vh",
//     overflowY: "auto",
//     boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)", // Adds depth
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px" // Space between form elements
// };

// const checkboxLabel = {
//     marginRight: "10px",
//     display: "inline-block"
// };

// export default Employee;













import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaSave, FaLock, FaUnlock } from "react-icons/fa";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider";
const Employee = () => {
    // const [employees, setEmployees] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editEmployeeId, setEditEmployeeId] = useState(null);
    const [vendorId, setVendorId] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    // Add this state variable inside your component
    const [unlockFields, setUnlockFields] = useState(false);

    // Add this function inside your component
    const toggleUnlockFields = () => {
        setUnlockFields(!unlockFields);
    };


    const [form, setForm] = useState({
        // firstName: "",
        // lastName: "",
        name: "",
        email: "",
        mobileNumber: "",
        city: "",
        businessCategory: "FOOD_AND_BEVERAGES",
        businessVerticals: [],
        username: "sddeda",
        password: "",
        role: "ROLE_VENDOR",
        roles: [], // ✅ IMPORTANT
        businessModules: [], // ✅

    });

    const businessVerticalOptions = [
        "FOOD_AND_BEVERAGES",
        "CATERINGS_SERVICES",
        "LOGISTICS_SUPPLY",
        "FRESH_GROCERIES",
    ];

    const toggleBusinessVertical = (vertical) => {
        setForm((prevForm) => {
            const currentVerticals = prevForm.businessVerticals || []; // ✅ Ensure array
            const updated = currentVerticals.includes(vertical)
                ? currentVerticals.filter((v) => v !== vertical)
                : [...currentVerticals, vertical];

            return { ...prevForm, businessVerticals: updated };
        });
    };
    const [data, setData] = useState([]);
    const [error, setError] = useState("");
    const getTableHeight = () => {
        const width = window.innerWidth;

        if (width <= 600) return "400px";               // Mobile
        if (width >= 1000 && width <= 1300) return "400px"; // 1000–1300px
        if (width > 1300) return "500px";               // Large screens

        return "auto";  // default
    };
    // Save token and vendorId to localStorage (do this once, e.g., after login)
    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken"); // ✅ Get token
    }, []);

    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            setError("Vendor ID or token not found in localStorage");
            return;
        }

        fetch(`https://backend.maamaas.com/subscription/api/get-employees/enquiry/${vendorId}`, {
            method: "GET",
            headers: {
                "Accept": "application/json", // ✅ better than "*/*"
                "Authorization": `Bearer ${token}`,
            },
        })
            .then(res => {
                if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
                return res.json();
            })
            .then(employees => {
                setData(employees);
            })
            .catch(err => {
                console.error("Fetch error:", err);
                setError(err.message);
            })
    }, []);





    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);
    const employeeData = {
        ...form,
        employeeRoles: form.employeeRoles, // ✅ Single role as enum value
    };


    const categories = ["Food", "Rooms", "BanquetHalls", "Fashions", "Groceries"];
    const modules = [
        "Home",
        "Company",
        "Settings_Controls",
        "Account_History",
        "Order_Management",
        "Menu_Management",
        "Inventory_Management",
        "Chef_Management",
        "Table_Management",
        "Delivery_Management",
        "Promotions_Discounts",
        "Report_Analysis"
    ];




    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const fetchEmployees = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            setError("Vendor ID or token not found in localStorage");
            return;
        }

        try {
            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/get-employees/enquiry/${vendorId}`,
                {
                    method: "GET",
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const employees = await response.json();
            setData(employees);
            setError("");
        } catch (err) {
            console.error("Fetch error:", err);
            setError(err.message);
        }
    };

    // Update the useEffect to use this function
    useEffect(() => {
        fetchEmployees();
    }, []);

    const roleOptions = [
        { label: "Manager", value: "Manager" },
        { label: "Waiter", value: "Waiter" },
        { label: "Chef All", value: "Chef_All" },
        { label: "Chef North", value: "Chef_North" },
        { label: "Chef South", value: "Chef_South" },
        { label: "Chef Chines", value: "Chef_Chinese" },
        { label: "Chef Continental", value: "Chef_Continental" },
        { label: "Tea Stall", value: "Tea_stall" },
        { label: "Snacks", value: "Snacks" },
        { label: "Bakery ", value: "Bakery" },
    ];

    const toggleRole = (roleValue) => {
        setForm((prevForm) => {
            const currentRoles = prevForm.roles || [];
            const newRoles = currentRoles.includes(roleValue)
                ? currentRoles.filter((r) => r !== roleValue)
                : [...currentRoles, roleValue];

            return { ...prevForm, roles: newRoles };
        });
    };







    const toggleModule = (module) => {
        setForm((prevForm) => {
            const current = prevForm.businessModules || [];
            const newModules = current.includes(module)
                ? current.filter((m) => m !== module)
                : [...current, module];
            return { ...prevForm, businessModules: newModules };
        });
    };


    const handleSubmit = async () => {
        const parentId = localStorage.getItem("vendorId");
        // const authToken = localStorage.getItem("authToken");

        if (!parentId) {
            alert("Parent ID not found. Please login again.");
            return;
        }

        const payload = {
            vendorId: 0,
            name: `${form.firstName} ${form.lastName}`,
            email: form.email,
            mobileNumber: form.mobileNumber,
            city: form.city || "Unknown",
            businessVerticals: form.businessVerticals || [],
            parentId: Number(parentId),
            username: "dsafre",
            password: form.password,
            enabled: true,
            employeRole: form.roles[0] || "Manager", // ✅ send only one role as string
            role: "ROLE_VENDOR",
            accountNonLocked: true,
            accountNonExpired: true,
            credentialsNonExpired: true,
            businessModules: form.businessModules || [],

        };

        try {
            showLoader();
            const response = await axios.post(
                "https://backend.maamaas.com/subscription/api/vendor/enquiry",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        // Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            alert("Employee added successfully!");
            setShowModal(false);   // Optional: Close modal
            window.location.reload(); // ✅ Reload the page
        } catch (error) {
            // console.error("❌ Error adding employee:", {
            //     message: error.message,
            //     status: error.response?.status,
            //     data: error.response?.data,
            // });
            alert("Failed to add employee.");
        } finally {
            hideLoader();
        }
    };

    const handleEditClick = (employee) => {
        setEditEmployeeId(employee.vendorId); // set ID
        setIsEditing(true); // modal is in edit mode
        setEditEmployeeId(employee.vendorId);
        setIsEditing(true);
        setUnlockFields(false);

        // Extract first and last name from the full name
        const fullName = employee.name || "";
        const nameParts = fullName.split(" ");
        const firstName = nameParts[0] || "";
        const lastName = nameParts.slice(1).join(" ") || "";

        // Pre-fill form with existing employee data
        setForm({
            name: employee.name || "", // Use the name directly
            email: employee.email || "",
            mobileNumber: employee.mobileNumber || "",
            username: employee.username || "",
            password: "", // Leave password empty for edit
            roles: employee.employeRole ? [employee.employeRole] : [],
            businessVerticals: employee.businessVerticals || [],
            businessModules: employee.businessModules || [],
        });

        setShowModal(true); // show modal
    };


    const updateEmployee = async () => {
        if (!editEmployeeId) {
            alert("❌ No employee selected for update.");
            return;
        }

        const parentId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!token) {
            alert("Authentication token not found. Please login again.");
            return;
        }

        // If personal fields are locked, don't send them to the API
        const payload = {
            vendorId: editEmployeeId,
            // Only include name/email/phone if they're unlocked
            ...(unlockFields && { name: form.name }),
            ...(unlockFields && { email: form.email }),
            ...(unlockFields && { mobileNumber: form.mobileNumber }),
            city: "Unknown",
            businessVerticals: form.businessVerticals || [],
            parentId: Number(parentId),
            username: form.username || "dsafre",
            // Only include password if it's not empty and unlocked
            ...(unlockFields && form.password && { password: form.password }),
            enabled: true,
            employeRole: form.roles[0] || "Manager",
            role: "ROLE_VENDOR",
            accountNonLocked: true,
            accountNonExpired: true,
            credentialsNonExpired: true,
            businessModules: form.businessModules || [],
        };

        // Remove undefined values from payload
        Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

        try {
            showLoader();

            const response = await axios.put(
                `https://backend.maamaas.com/subscription/api/edit/enquiry/${editEmployeeId}`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                alert("✅ Employee updated successfully!");

                // Update the local state
                setData(prevData =>
                    prevData.map(employee =>
                        employee.vendorId === editEmployeeId
                            ? {
                                ...employee,
                                // Only update name/email/phone if they were unlocked
                                ...(unlockFields && { name: payload.name }),
                                ...(unlockFields && { email: payload.email }),
                                ...(unlockFields && { mobileNumber: payload.mobileNumber }),
                                employeRole: payload.employeRole,
                                businessVerticals: payload.businessVerticals,
                                businessModules: payload.businessModules
                            }
                            : employee
                    )
                );

                setShowModal(false);
                setIsEditing(false);
                setEditEmployeeId(null);
                setUnlockFields(false);
            } else {
                throw new Error(`Update failed with status: ${response.status}`);
            }
        } catch (error) {
            console.error("❌ Update failed:", error);
            alert(`Update failed: ${error.response?.data?.message || error.message}`);
        } finally {
            hideLoader();
        }
    };



    const handleDelete = async (vendorId) => {
        if (!vendorId) return alert("Invalid employee ID");

        const token = localStorage.getItem("token"); // get token from localStorage /api/delete/enquiry/{id}
        if (!token) return alert("Token not found");

        try {
            const res = await fetch(
                `https://backend.maamaas.com/subscription/api/delete/enquiry/${vendorId}`,
                {
                    method: "DELETE",
                    headers: {
                        "accept": "*/*",
                        "Authorization": `Bearer ${token}`, // token included
                    },
                }
            );

            if (!res.ok) throw new Error(`Failed to delete. Status ${res.status}`);

            // Remove the deleted employee from state
            setData((prev) => prev.filter((emp) => emp.vendorId !== vendorId));
            alert("Employee deleted successfully.");
        } catch (err) {
            alert("Delete Error: " + err.message);
        }
    };




    const tableCellStyle = {
        border: "1px solid #ddd",
        padding: "8px",
    };
    const buttonStyle = {

        backgroundColor: '#dc3545',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        marginRight: "5px"
    };

    return (
        <div className="billingswaraper" style={{ padding: "10px", marginTop: "10px", width: window.innerWidth >= 992 ? "55vw" : "90vw", marginLeft: window.innerWidth < 769 ? "2vw" : "2vw" }}>
            <button onClick={() => {
                setShowModal(true);
                setIsEditing(false);
                setEditIndex(null);
                setUnlockFields(true); // Unlock fields for add mode
                setForm({
                    firstName: "",
                    lastName: "",
                    email: "",
                    mobileNumber: "",
                    employeeRoles: [],
                    businessCategory: "FOOD_AND_BEVERAGES",
                    businessModules: [],
                    username: "",
                    password: "",
                });
            }} style={addButtonStyle}>Add +</button>
            <div style={{ height: getTableHeight(), overflowY: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
                    <thead>
                        <tr>
                            <th style={thStyle}>S.No</th>
                            <th style={thStyle}>Name</th>

                            <th style={thStyle}>Email</th>
                            <th style={thStyle}>Mobile</th>
                            <th style={thStyle}>Role</th>
                            <th style={thStyle}>businessVerticals</th>
                            <th style={thStyle}>Modules</th>
                            <th style={thStyle}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan="9" style={tableCellStyle}>
                                    {error ? `⚠️ ${error}` : "Loading…"}
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index) => (
                                <tr key={item.vendorId || index}>
                                    <td style={tableCellStyle}>{index + 1}</td>
                                    <td style={tableCellStyle}>{item.name}</td>
                                    <td style={tableCellStyle}>{item.email}</td>
                                    <td style={tableCellStyle}>{item.mobileNumber}</td>
                                    <td style={tableCellStyle}>{item.employeRole}</td>
                                    <td style={tableCellStyle}>{item.businessVerticals.join(", ")}</td>
                                    <td style={tableCellStyle}>
                                        {item.businessModules.map((module, idx) => (
                                            <span key={idx}>
                                                {module}
                                                <br />
                                            </span>
                                        ))}
                                    </td>
                                    <td style={{ ...tableCellStyle, padding: window.innerWidth < 1300 ? "5px" : " " }}>
                                        {/* Edit button */}
                                        <button
                                            type="button"
                                            onClick={() => handleEditClick(item)}
                                            style={{
                                                ...buttonStyle,
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                fontSize: "18px",
                                                color: "#4A148C",
                                                marginRight: window.innerWidth < 1300 ? " " : "8px",
                                            }}
                                        >
                                            <FaEdit />
                                        </button>


                                        {/* Delete button */}
                                        <button
                                            type="button"
                                            onClick={() => handleDelete(item.vendorId)}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                fontSize: "18px",
                                                color: "red",
                                            }}
                                            title="Delete Employee"
                                        >
                                            <FaTrash />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>



                </table>
            </div>
            {showModal && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h3 style={{ margin: 0 }}>{isEditing ? "Edit Employee" : "Add Employee"}</h3>
                            {isEditing && (
                                <button
                                    onClick={toggleUnlockFields}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        color: unlockFields ? '#4CAF50' : '#888',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        padding: '5px 10px',
                                        borderRadius: '4px',
                                        border: `1px solid ${unlockFields ? '#4CAF50' : '#ddd'}`
                                    }}
                                    type="button"
                                >
                                    {unlockFields ? <FaUnlock /> : <FaLock />}
                                    {/* {unlockFields ? 'Unlocked' : 'Edit Personal Info'} */}
                                </button>
                            )}
                        </div>

                        {/* Name Field */}
                        <div style={{ marginBottom: '0px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                <label style={{ fontWeight: '500', flex: 1 }}>Full Name</label>
                                {isEditing && !unlockFields && (
                                    <span style={{ fontSize: '12px', color: '#888', marginLeft: '10px' }}>
                                        {/* (Locked - click "Edit Personal Info" to edit) */}
                                    </span>
                                )}
                            </div>
                            <input
                                type="text"
                                name="name"
                                placeholder="Full Name"
                                value={form.name}
                                onChange={handleChange}
                                style={{
                                    ...inputStyle,
                                    backgroundColor: isEditing && !unlockFields ? '#f5f5f5' : 'white',
                                    cursor: isEditing && !unlockFields ? 'not-allowed' : 'text',
                                    opacity: isEditing && !unlockFields ? 0.7 : 1
                                }}
                                readOnly={isEditing && !unlockFields}
                            />
                        </div>

                        {/* Email Field */}
                        <div style={{ marginBottom: '0px' }}>
                            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Email</label>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={form.email}
                                onChange={handleChange}
                                style={{
                                    ...inputStyle,
                                    backgroundColor: isEditing && !unlockFields ? '#f5f5f5' : 'white',
                                    cursor: isEditing && !unlockFields ? 'not-allowed' : 'text',
                                    opacity: isEditing && !unlockFields ? 0.7 : 1
                                }}
                                readOnly={isEditing && !unlockFields}
                            />
                        </div>

                        {/* Mobile Number Field */}
                        <div style={{ marginBottom: '0px' }}>
                            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Mobile Number</label>
                            <input
                                type="text"
                                name="mobileNumber"
                                placeholder="Mobile Number"
                                value={form.mobileNumber}
                                onChange={handleChange}
                                style={{
                                    ...inputStyle,
                                    backgroundColor: isEditing && !unlockFields ? '#f5f5f5' : 'white',
                                    cursor: isEditing && !unlockFields ? 'not-allowed' : 'text',
                                    opacity: isEditing && !unlockFields ? 0.7 : 1
                                }}
                                readOnly={isEditing && !unlockFields}
                            />
                        </div>

                        {/* Business Verticals (Always Editable) */}
                        <div style={{ marginTop: "10px", marginBottom: '15px' }}>
                            <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                                Business Verticals:
                            </label>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                                {businessVerticalOptions.map((vertical) => (
                                    <label key={vertical} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                                        <input
                                            type="checkbox"
                                            checked={form.businessVerticals?.includes(vertical)}
                                            onChange={() => toggleBusinessVertical(vertical)}
                                            style={{ marginRight: "6px", cursor: "pointer" }}
                                        />
                                        {vertical.replace(/_/g, " ")}
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Roles (Always Editable) */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Roles:</label>
                            <div style={{ display: "flex", flexWrap: "wrap", marginTop: "8px", gap: "10px" }}>
                                {roleOptions.map(({ label, value }) => (
                                    <label key={value} style={{ display: "flex", alignItems: "center" }}>
                                        <input
                                            type="checkbox"
                                            checked={form.roles?.includes(value)}
                                            onChange={() => toggleRole(value)}
                                            style={{ marginRight: "5px" }}
                                        />
                                        {label}
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Modules (Always Editable) */}
                        <div style={{ marginTop: "10px", marginBottom: '15px' }}>
                            <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                                Modules:
                            </label>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                                {modules.map((module) => (
                                    <label key={module} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                                        <input
                                            type="checkbox"
                                            checked={form.businessModules.includes(module)}
                                            onChange={() => toggleModule(module)}
                                            style={{ marginRight: "6px", cursor: "pointer" }}
                                        />
                                        {module.replace(/_/g, " ")}
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div style={{ marginTop: "20px", textAlign: "right", borderTop: '1px solid #eee', paddingTop: '15px' }}>
                            <button
                                style={{
                                    padding: "8px 15px",
                                    backgroundColor: "#4CAF50",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    marginRight: "10px",
                                    cursor: "pointer",
                                    fontWeight: 'bold'
                                }}
                                onClick={isEditing ? updateEmployee : handleSubmit}
                            >
                                {isEditing ? "Update Employee" : "Add Employee"}
                            </button>
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    setIsEditing(false);
                                    setEditIndex(null);
                                    setUnlockFields(false);
                                    setForm({
                                        name: "",
                                        email: "",
                                        mobileNumber: "",
                                        employeeRoles: [],
                                        businessCategory: "FOOD_AND_BEVERAGES",
                                        businessModules: [],
                                        username: "",
                                        password: "",
                                    });
                                }}
                                style={{
                                    ...cancelButton,
                                    backgroundColor: '#f5f5f5',
                                    color: '#333',
                                    border: '1px solid #ddd'
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
//  all the 

// Styles
const thStyle = {
    border: "1px solid #ccc",
    backgroundColor: "#b15cd6",
    color: "#fff",
    padding: "8px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "150px"
};

const tdStyle = {
    border: "1px solid #ccc",
    textAlign: "center",
    padding: "8px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "97px",
    width: "150px",
    boxSizing: "border-box"
};

const evenRow = { backgroundColor: "#f9f9f9" };
const oddRow = { backgroundColor: "#fff" };
const inputStyle = { width: "100%", margin: "5px 0", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" };
const addButtonStyle = { padding: "8px 15px", backgroundColor: "#b15cd6", color: "#fff", border: "none", borderRadius: "4px", fontWeight: "bold", fontSize: "16px", marginBottom: "10px" };
const saveButton = { padding: "8px 15px", backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", marginRight: "10px" };
const cancelButton = { padding: "8px 15px", backgroundColor: "#f44336", color: "#fff", border: "none", borderRadius: "4px" };
const deleteButtonStyle = { backgroundColor: "#f44336", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
const deleteButtonStylee = { backgroundColor: "blue", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
const modalOverlay = {
    position: "fixed",
    top: window.innerWidth < 500 ? 20 : 35,
    left: 0,
    zIndex: 1111,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};
const modalContent = {
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "12px",
    width: window.innerWidth < 500 ? "80%" : "100%",
    maxWidth: "500px",
    maxHeight: window.innerWidth < 500 ? "80vh" : "90vh",
    overflowY: "auto",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)", // Adds depth
    display: "flex",
    flexDirection: "column",
    gap: "16px" // Space between form elements
};

const checkboxLabel = {
    marginRight: "10px",
    display: "inline-block"
};

export default Employee;

